import { cn } from "@/lib/utils";
import { useTabNavigation } from "@/stores/use-nav-store";
import { Menu, Bookmark, User, Users, MessageCircleQuestion } from "lucide-react";
import { Link } from "react-router";
import { useUserback } from "../providers/UserBackProvider";

type NavItem =
  | { id: string; icon: typeof Menu; type: "link"; href: string; }
  | { id: string; icon: typeof Menu; type?: "button" | undefined; };

  const navItems: NavItem[] = [
  { id: "community", type: "link", href: "/community", icon: Users },
  { id: "menu", type: "link", href: "/", icon: Menu },
  { id: "bookmarks", type: "link", href: "/", icon: Bookmark },
  { id: "profile", type: "link", href: "/", icon: User },
];

export default function BottomNavigation() {
  const { activeTab, setActiveTab } = useTabNavigation();
  const { handleOpenForm } = useUserback();
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 lg:hidden">
      <div
        className="rounded-full p-[0.2rem] shadow-lg"
        style={{
          background: "linear-gradient(to bottom, #FFFFFFBB, #FFFFFFFF)",
          boxShadow: "0 10px 25px #0000001F",
        }}
      >
        <div className="flex items-center space-x-5">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            const className = `
              p-3 rounded-full transition-all duration-100 ease-in-out
              focus:outline-none active:scale-105 cursor-pointer
              min-w-[48px] min-h-[48px] flex items-center justify-center
              ${isActive
                ? "bg-blue-500 text-white shadow-lg"
                : "text-gray-700 hover:text-gray-800 hover:bg-gray-200 hover:bg-opacity-50"
              }
            `;

            const iconElement = (
              <Icon
                size={24}
                className={cn(
                  "transition-colors duration-300",
                  isActive ? "text-white fill-white" : "text-gray-700 fill-none"
                )}
              />
            );

            if (item.type === "link" && "href" in item) {
              return (
                <Link
                  to={item.href}
                  key={item.id}
                  className={className}
                  tabIndex={0}
                  role="button"
                  onClick={() => setActiveTab(item.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setActiveTab(item.id);
                  }}
                >
                  {iconElement}
                </Link>
              );
            }

            return (
              <div
                key={item.id}
                className={className}
                tabIndex={0}
                role="button"
                onClick={() => setActiveTab(item.id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setActiveTab(item.id);
                }}
              >
                {iconElement}
              </div>
            );
          })}
          <div className="p-3 rounded-full transition-all duration-100 ease-in-out
              focus:outline-none active:scale-105 cursor-pointer
              min-w-[48px] min-h-[48px] flex items-center justify-center" onClick={handleOpenForm}><MessageCircleQuestion className="text-black" /></div>
        </div>
      </div>
    </div>
  );
}
